<div class="modal-body">
    <button type="button" class="btn-close close pull-right btnCloseModal" aria-label="Close" (click)="closeButtonClick()"
    id="btnCloseModalBaja">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>

    <h4 class="pruebah4">Baja lead:</h4>
    <p>Exponga el motivo de la baja del lead: </p>

    <form [formGroup]="formBajaLead" class="formBajaLead">
        <div>
            <div class="ps--form-radio mr-2">
                <input
                  formControlName="radioBajaReason"
                  type="radio"
                  id="radioNoInteresado"
                  name="radioBajaReason"
                  class="sr-only"
                  value="H"
                  (change)="bajaReasonChange()"
                />
                <label for="radioNoInteresado">
                  <em class="bi bi-circle"></em>
                  <em class="bi bi-record-circle"></em>
                  Orden del cliente</label
                >
            </div>

            <div class="ps--form-radio mr-2">
                <input
                  formControlName="radioBajaReason"
                  type="radio"
                  id="radioError"
                  name="radioBajaReason"
                  class="sr-only"
                  value="I"
                  (change)="bajaReasonChange()"
                />
                <label for="radioError">
                  <em class="bi bi-circle"></em>
                  <em class="bi bi-record-circle"></em>
                  Error en lead</label
                >
            </div>

            <div class="ps--form-radio mr-2 mt-2 d-flex flex-row align-items-center">
                <input
                  formControlName="radioBajaReason"
                  type="radio"
                  id="radioOtros"
                  name="radioBajaReason"
                  class="sr-only"
                  value="J"
                  (change)="bajaReasonChange()"
                />
                <label for="radioOtros">
                  <em class="bi bi-circle"></em>
                  <em class="bi bi-record-circle"></em>
                  Otro:
                </label>

                <div class="col-9 ps--input-box textareaBaja"
                  [ngClass]=" { 'disabled-container' : obsBajaContainerDisabled }">
                    <textarea
                        formControlName="observacionesBaja"
                        id="obsBaja"
                        type="text"
                        name="obs"
                        aria-label="Obsservacionses"
                        placeholder="Observaciones"
                        autocomplete="off"
                        maxlength="255"
                        pattern="^[a-zA-ZÀ-ÿ0-9ñ. -]+$"
                        [ngClass]="{ 'observacionesBajaDisabled' : obsBajaDisabled }"
                    ></textarea>
                  </div>
            </div>
        </div>

        <div class="d-flex justify-content-end mt-4 mr-3">
            <button
              id="cancelar"
              class="btn ps--btn ps--btn-cancel mr-4"
              (click)="closeButtonClick()"
              (keypress)="closeButtonClick()"
              tabindex="110"
            >
              Cancelar
            </button>

            <button
              id="entrar"
              class="btn ps--btn ps--btn-primary"
              type="submit"
              (click)="onSubmitBaja()"
              (keypress)="onSubmitBaja()"
              tabindex="120"
            >
              Enviar
            </button>
        </div>
    </form>

    <ng-template #faltaMotivo>
        <div class="modal-body modalBodyFaltaMotivo">
            <img src="../../../assets/images/DOC002.png" alt="advertencia icono" />
            <p>{{mensajeModalAdvertencia}}</p>

            <button
              id="aceptar"
              class="btn ps--btn ps--btn-primary"
              (click)="modalRef2.hide()"
              (keypress)="modalRef2.hide()"
              tabindex="110"
            >
              De acuerdo
            </button>
        </div>
    </ng-template>

    <ng-template #confirmacion>
        <div class="modal-body modalBodyFaltaMotivo">
            <img src="../../../assets/images/question-circle.svg" alt="pregunta icono" />
            <p>¿Desea confirmar la baja del lead?</p>

            <div class="botonesConfirmacion">
                <button
                id="cancelar-confirmacion"
                class="btn ps--btn ps--btn-cancel mr-4"
                (click)="modalRef3.hide()"
                (keypress)="modalRef3.hide()"
                tabindex="110"
                >
                    Cancelar
                </button>

                <button
                id="confirmar"
                class="btn ps--btn ps--btn-primary"
                type="submit"
                (click)="onSubmitConfirmacion()"
                (keypress)="onSubmitConfirmacion()"
                tabindex="120"
                >
                    Confirmar
                </button>
            </div>
        </div>
    </ng-template>
</div>
